/* Petso Mix & Save builder — scoped to [data-petso-mix-builder] */
  (() => {
    const money = (cents) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
    const init = (root) => {
      if (!root || root.dataset.petsoMixReady === 'true') return;
      root.dataset.petsoMixReady = 'true';
      const rules = JSON.parse(root.querySelector('[data-petso-mix-rules]').textContent);
      const byKey = new Map(rules.map((rule) => [rule.key, rule]));
      const drafts = new Map(rules.map((rule) => [rule.key, new Map()]));
      const rangeNav = root.querySelector('[data-petso-mix-range-nav]');
      const confirmation = root.querySelector('[data-petso-mix-added-confirmation]');
      let activeKey = rules[0].key;

      const all = (selector) => [...root.querySelectorAll(selector)];
      const activePanel = () => root.querySelector('[data-petso-mix-panel="' + activeKey + '"]');
      const activeRows = () => [...activePanel().querySelectorAll('[data-petso-mix-product]')];
      const setText = (selector, value) => all(selector).forEach((node) => { node.textContent = value; });

      const calculate = () => {
        const rule = byKey.get(activeKey);
        const draft = drafts.get(activeKey);
        const selected = activeRows().map((row) => ({
          row,
          id: Number(row.dataset.variantId),
          quantity: draft.get(row.dataset.variantId) || 0,
          price: Number(row.dataset.priceCents),
          compareAt: Number(row.dataset.compareAtCents || 0),
          label: row.dataset.label,
          title: row.dataset.title,
          image: row.dataset.image,
        })).filter((item) => item.quantity > 0);
        const quantity = selected.reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = selected.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const rrpSaving = selected.reduce((sum, item) => sum + Math.max(item.compareAt - item.price, 0) * item.quantity, 0);
        let mixSaving = 0;
        let progress = Math.min(quantity / rule.threshold, 1);
        let progressText = 'Choose your favourites to get started';
        let badge = 'Choose your favourites to unlock this saving';
        let unlocked = false;

        if (rule.discountType === 'fixed_group') {
          const groups = Math.floor(quantity / rule.threshold);
          const remainder = quantity % rule.threshold;
          mixSaving = groups * rule.valueCents;
          unlocked = groups > 0;
          progress = quantity === 0 ? 0 : (remainder === 0 && groups > 0 ? 1 : remainder / rule.threshold);
          if (quantity > 0 && groups === 0) progressText = 'Add ' + (rule.threshold - quantity) + ' more ' + rule.unit + (rule.threshold - quantity === 1 ? '' : 's') + ' to unlock ' + money(rule.valueCents) + ' off';
          if (groups > 0 && remainder === 0) progressText = groups + ' offer' + (groups === 1 ? '' : 's') + ' unlocked · Add ' + rule.threshold + ' more for another ' + money(rule.valueCents) + ' off';
          if (groups > 0 && remainder > 0) progressText = groups + ' offer' + (groups === 1 ? '' : 's') + ' unlocked · Add ' + (rule.threshold - remainder) + ' more for another ' + money(rule.valueCents) + ' off';
          if (unlocked) badge = 'You unlocked ' + money(mixSaving) + ' off';
        } else if (rule.discountType === 'per_item_threshold') {
          unlocked = quantity >= rule.threshold;
          if (unlocked) {
            mixSaving = quantity * rule.valueCents;
            progress = 1;
            progressText = 'Offer unlocked · ' + money(rule.valueCents) + ' off per ' + rule.unit + ' applies in cart';
            badge = 'You unlocked ' + money(mixSaving) + ' off';
          } else if (quantity > 0) {
            progressText = 'Add ' + (rule.threshold - quantity) + ' more ' + rule.unit + (rule.threshold - quantity === 1 ? '' : 's') + ' to unlock ' + money(rule.valueCents) + ' off per ' + rule.unit;
          }
        } else if (rule.discountType === 'fixed_threshold') {
          unlocked = quantity >= rule.threshold;
          if (unlocked) {
            mixSaving = rule.valueCents;
            progress = 1;
            progressText = 'Offer unlocked · ' + money(rule.valueCents) + ' off applies in cart';
            badge = 'You unlocked ' + money(rule.valueCents) + ' off';
          } else if (quantity > 0) {
            progressText = 'Add ' + (rule.threshold - quantity) + ' more ' + rule.unit + (rule.threshold - quantity === 1 ? '' : 's') + ' to unlock ' + money(rule.valueCents) + ' off';
          }
        } else {
          unlocked = quantity >= rule.threshold;
          if (unlocked) {
            mixSaving = selected.reduce((sum, item) => sum + Math.floor(item.price * rule.valuePercent / 100) * item.quantity, 0);
            progress = 1;
            progressText = 'Offer unlocked · ' + rule.valuePercent + '% off applies in cart';
            badge = 'You unlocked an extra ' + rule.valuePercent + '% off';
          } else if (quantity > 0) {
            progressText = 'Add ' + (rule.threshold - quantity) + ' more ' + rule.unit + (rule.threshold - quantity === 1 ? '' : 's') + ' to unlock ' + rule.valuePercent + '% off';
          }
        }
        return { rule, selected, quantity, subtotal, rrpSaving, mixSaving, finalPrice: Math.max(subtotal - mixSaving, 0), progress, progressText, badge, unlocked };
      };

      const render = () => {
        const state = calculate();
        setText('[data-petso-summary-qty]', String(state.quantity));
        setText('[data-petso-progress-text]', state.progressText);
        setText('[data-petso-subtotal]', money(state.subtotal));
        setText('[data-petso-mix-saving]', '−' + money(state.mixSaving));
        setText('[data-petso-rrp-saving]', money(state.rrpSaving));
        setText('[data-petso-final-price]', money(state.finalPrice));
        setText('[data-petso-saving-badge]', state.badge);
        setText('[data-petso-active-threshold]', 'Choose any ' + state.rule.threshold + ' ' + state.rule.unit + (state.rule.threshold === 1 ? '' : 's'));
        setText('[data-petso-active-saving]', state.rule.savingLabel);
        setText('[data-petso-active-instruction]', state.rule.instruction);
        setText('[data-petso-active-exclusion]', state.rule.exclusion);
        all('[data-petso-progress-bar]').forEach((bar) => { bar.style.width = Math.round(state.progress * 100) + '%'; });
        all('[data-petso-saving-badge]').forEach((badge) => badge.classList.toggle('is-unlocked', state.unlocked));
        all('[data-petso-range-count]').forEach((badge) => {
          const total = [...drafts.get(badge.dataset.petsoRangeCount).values()].reduce((sum, count) => sum + count, 0);
          badge.hidden = total === 0;
          badge.textContent = total + ' selected';
        });
        all('[data-petso-add-all]').forEach((button) => {
          button.disabled = state.quantity === 0;
          button.textContent = state.unlocked ? 'Add Mix & Save to cart' : 'Add selections to cart';
        });
        const list = root.querySelector('[data-petso-selected-list]');
        list.innerHTML = state.selected.length ? state.selected.map((item) => '<div class="petso-mix-box__item"><img src="' + item.image + '" alt=""><div><strong>' + item.label + '</strong><span>' + money(item.price) + ' each</span></div><b>' + item.quantity + ' ×</b></div>').join('') : '<p class="petso-mix-box__empty">Your selected products will appear here.</p>';
      };

      const switchRule = (nextKey) => {
        activeKey = nextKey;
        all('[data-petso-mix-panel]').forEach((panel) => { panel.hidden = panel.dataset.petsoMixPanel !== activeKey; });
        all('[data-petso-mix-range]').forEach((button) => {
          const selected = button.dataset.petsoMixRange === activeKey;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
        });
        activeRows().forEach((row) => {
          const quantity = drafts.get(activeKey).get(row.dataset.variantId) || 0;
          row.querySelector('[data-petso-qty-output]').textContent = String(quantity);
          row.querySelector('[data-petso-qty-minus]').disabled = quantity === 0;
        });
        render();
      };

      rangeNav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-petso-mix-range]');
        if (button) switchRule(button.dataset.petsoMixRange);
      });
      rangeNav.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = all('[data-petso-mix-range]');
        const currentIndex = buttons.findIndex((button) => button.dataset.petsoMixRange === activeKey);
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (currentIndex + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        event.preventDefault();
        const next = buttons[nextIndex];
        switchRule(next.dataset.petsoMixRange);
        next.focus();
      });
      root.addEventListener('click', (event) => {
        const plus = event.target.closest('[data-petso-qty-plus]');
        const minus = event.target.closest('[data-petso-qty-minus]');
        if (!plus && !minus) return;
        const row = event.target.closest('[data-petso-mix-product]');
        const draft = drafts.get(activeKey);
        const current = draft.get(row.dataset.variantId) || 0;
        const next = Math.max(0, current + (plus ? 1 : -1));
        draft.set(row.dataset.variantId, next);
        row.querySelector('[data-petso-qty-output]').textContent = String(next);
        row.querySelector('[data-petso-qty-minus]').disabled = next === 0;
        render();
      });

      all('[data-petso-add-all]').forEach((button) => button.addEventListener('click', async () => {
        const state = calculate();
        if (!state.selected.length) return;
        const buttons = all('[data-petso-add-all]');
        const error = root.querySelector('[data-petso-error]');
        buttons.forEach((item) => { item.disabled = true; item.textContent = 'Adding your box…'; });
        error.hidden = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: state.selected.map((item) => ({ id: item.id, quantity: item.quantity })) }),
          });
          if (!response.ok) throw new Error('We could not add this selection. Please try again.');
          drafts.get(activeKey).clear();
          render();
          confirmation.hidden = false;
          confirmation.focus();
        } catch (exception) {
          error.textContent = exception.message || 'We could not add your selection. Please try again.';
          error.hidden = false;
          render();
        }
      }));

      root.querySelector('[data-petso-shop-another]').addEventListener('click', () => {
        confirmation.hidden = true;
        rangeNav.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => root.querySelector('[data-petso-mix-range="' + activeKey + '"]')?.focus(), 180);
      });

      const floatingTargets = [
        { target: root.querySelector('.petso-mix-box'), placeholder: root.querySelector('[data-petso-box-placeholder]'), media: window.matchMedia('(min-width: 990px)'), top: 14, fixedWidth: true },
        { target: root.querySelector('[data-petso-mobile-summary]'), placeholder: root.querySelector('[data-petso-mobile-placeholder]'), media: window.matchMedia('(max-width: 989px)'), top: 0, fixedWidth: false },
      ];
      let floatingFrame = 0;
      const syncFloating = () => {
        floatingFrame = 0;
        floatingTargets.forEach(({ target, placeholder, media, top, fixedWidth }) => {
          if (!target || !placeholder || !media.matches) {
            target?.classList.remove('is-petso-mix-floating');
            placeholder && (placeholder.style.height = '0px');
            return;
          }
          const slot = placeholder.getBoundingClientRect();
          const targetHeight = target.offsetHeight;
          const shouldFloat = slot.top <= top && root.getBoundingClientRect().bottom > targetHeight + top + 12;
          if (shouldFloat && fixedWidth) {
            target.style.setProperty('--petso-mix-fixed-left', slot.left + 'px');
            target.style.setProperty('--petso-mix-fixed-width', slot.width + 'px');
          }
          target.classList.toggle('is-petso-mix-floating', shouldFloat);
          placeholder.style.height = shouldFloat ? targetHeight + 'px' : '0px';
        });
      };
      const requestFloatingSync = () => {
        if (floatingFrame) return;
        floatingFrame = requestAnimationFrame(syncFloating);
      };
      window.addEventListener('scroll', requestFloatingSync, { passive: true });
      window.addEventListener('resize', requestFloatingSync);

      switchRule(activeKey);
      syncFloating();
    };

    const initAll = () => document.querySelectorAll('[data-petso-mix-builder]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-petso-mix-builder]')));
  })();
